export default {
    code: 'BUS_AZ_AZERBAIJAN_AIRLINES',
    content: {
        logo: {
            dark: 'https://res.cloudinary.com/carbonclick/image/upload/v1725957042/cms-qualeu/MERCHANT/BUS_AZ_AZERBAIJAN_AIRLINES/logo-dark.png',
            light: 'https://res.cloudinary.com/carbonclick/image/upload/v1725957030/cms-qualeu/MERCHANT/BUS_AZ_AZERBAIJAN_AIRLINES/logo-light.png',
            link: 'https://azerbaijanairlines.carbon.click/'
        },
        menu: {
            menuIconColor: true,
            url: 'https://azerbaijanairlines.carbon.click/',
        },
        myMovementPanel: {
            hideMovementInvitation: true,
            hideMovementCreation: true,
        },
    },
    theme: {
        images: {
            hero: {
                main: 'url(\'https://res.cloudinary.com/carbonclick/image/upload/v1770368642/White%20Label/Azerbaijan%20Airlines/hero-image_r09zph.jpg\')',
            },
        }
    },
}
